import { useQuery } from "@tanstack/react-query";

import {
  getSurveyDetailQueryOptions,
  getSurveyReportQueryOptions,
  getSurveysListQueryOptions,
} from "../queries/survey-queries";

export function useSurveysList() {
  return useQuery(getSurveysListQueryOptions());
}

export function useSurvey(uuid: string) {
  return useQuery(getSurveyDetailQueryOptions(uuid));
}

export function useSurveyReport(uuid: string) {
  return useQuery(getSurveyReportQueryOptions(uuid));
}
